/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Link, Report, RestResponse} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';
import { ModuleType } from '../model/enums/module.type';

@Injectable()
export class ReportLinksProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getLinks(report: Report, state?: string, type?: string): Observable<RestResponse> {
    let optionals = '';

    if (state)
      optionals += ('state=' + state);

    if (type) {
      if (optionals.length > 0)
        optionals += '&';

      optionals += ('type=' + type);
    }

    if (optionals.length > 0)
      optionals = '?' + optionals;

    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${report.ID}/link${optionals}`,
        ApiHeaders.getOptions());
  }

  createLink(report: Report, module: ModuleType): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${report.ID}/link?module=${module}`, null, ApiHeaders.getOptions());
  }

  updateLink(report: Report, link: Link): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${report.ID}/link/${link.ID}`, link, ApiHeaders.getOptions());
  }

  deleteLink(report: Report, id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/pma/report/${report.ID}/link/${id}`, ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'REPORT_LINKS';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return undefined;
  }
}
